module.exports = __webpack_public_path__ + "static/img/1.5ccbbdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/1.png
// module id = BbY/
// module chunks = 0